var map = {
	"./additionalInfoIcon.svg": 590,
	"./arrowLeftIcon.svg": 591,
	"./arrowMediumTop.svg": 592,
	"./arrowRightIcon.svg": 593,
	"./arrowRightIconSharp.svg": 594,
	"./arrowRightSmallIcon.svg": 595,
	"./arrowScalableIcon.svg": 596,
	"./arrowSelect2.svg": 597,
	"./arrowSelectIcon.svg": 598,
	"./benefit1.svg": 599,
	"./benefit2.svg": 600,
	"./benefit3.svg": 601,
	"./cardsIcon.svg": 602,
	"./copyIcon copy.svg": 603,
	"./copyIcon.svg": 604,
	"./crossIcon.svg": 605,
	"./crossIcon2.svg": 606,
	"./crossIcon3.svg": 607,
	"./crossIconSmall.svg": 608,
	"./crossSmallIcon.svg": 609,
	"./defaultCategoryIcon.svg": 610,
	"./depNumberIcon.svg": 611,
	"./elfCentralIcon.svg": 612,
	"./equalitySign.svg": 613,
	"./errorIcon.svg": 351,
	"./eyeClosedIcon.svg": 614,
	"./eyeOpenIcon.svg": 615,
	"./favoritesIcon.svg": 616,
	"./favoritesLabelIcon.svg": 617,
	"./filterDivider.svg": 618,
	"./filterIcon.svg": 619,
	"./frequencyIcon.svg": 620,
	"./fsAmountIcon.svg": 621,
	"./fullScreenIcon.svg": 622,
	"./gameIcon.svg": 623,
	"./hamburgerIcon.svg": 624,
	"./infoIcon.svg": 625,
	"./infoSymbol.svg": 626,
	"./levelBackground.svg": 627,
	"./levelBackgroundNew.svg": 628,
	"./linkIcon.svg": 629,
	"./lockIcon.svg": 630,
	"./lockSharpIcon.svg": 631,
	"./maxBonusAmountIcon.svg": 632,
	"./maxWinFsIcon.svg": 633,
	"./menuIcon.svg": 634,
	"./minDepIcon.svg": 635,
	"./noTournamentIcon.svg": 636,
	"./playIcon.svg": 637,
	"./polygon.svg": 638,
	"./preloaderDotsAnimation.svg": 639,
	"./preloaderSpinnerAnimation.svg": 640,
	"./presentIcon.svg": 641,
	"./promoIcon.svg": 642,
	"./recentIcon.svg": 643,
	"./search2Icon.svg": 644,
	"./search3Icon.svg": 645,
	"./sharpTickIcon copy.svg": 646,
	"./sharpTickIcon.svg": 647,
	"./smallInfoSymbol.svg": 648,
	"./smoothArrowIcon.svg": 649,
	"./successIcon.svg": 650,
	"./supportIcon.svg": 651,
	"./tag1Icon.svg": 652,
	"./tag2Icon.svg": 653,
	"./tag3Icon.svg": 654,
	"./tag4Icon.svg": 655,
	"./tickIcon.svg": 656,
	"./unverified.svg": 657,
	"./verified.svg": 658,
	"./wagerIcon.svg": 659,
	"./wagerTimeIcon.svg": 660,
	"./warningIcon.svg": 661
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 589;